export default "__VITE_ASSET__24b8df64__"